/* eslint-disable react/destructuring-assignment */
/* eslint-disable prefer-destructuring */
/* eslint-disable operator-linebreak */
/* eslint-disable object-curly-newline */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/prop-types */

/* global fetch, window, document */

import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import './VideoProjectPage.css';
import LockImage from '../../../img/svg/Lock.svg';
import ProfileIcon from '../../../modules/Navbar/img/3073050-200.png';
import Reiter from './Reiter';
import Details from './Details';
import Team from './Team';
import Links from './Links';
import Teilen from './Teilen';
import MediaPlayer from '../../MediaPlayer/MediaPlayer';
import LoadingSpinner from './LoadingSpinner';
import Images from './Images';
import SliderComponent from '../../../modules/Slider/SliderComponent';
import MainWrapper from '../../../modules/Slider/MainWrapper';
import Download from './Download';
import NameTag from './NameTag';
import { createCookie, readCookie } from '../../../handleCookieData';
import handleCharacterEncoding from '../../../handleCharacterEncoding';

// import global constants
import { NOT_AUTHORIZED, OEFFENTLICH } from '../../../constants';

/**
 * Renders a page for a specific project with all its details, media and additional information.
 * @param {string} props.match.params.id - Project ID from React Router's routing parameters
 * @param {boolean} props.userIsAuthenticated - Indicates if the user is authenticated
 * @param {boolean} props.onlyShowPublicProjects - Indicates if only public projects should be shown
 */
function VideoProjectPage(props) {
  const { userIsAuthenticated, onlyShowPublicProjects } = props;
  const [projectId, setProjectId] = useState(props.match.params.id);

  // STATES
  const [projectData, setProjectData] = useState([
    {
      projekt_ID: '',
      projekt_titel: '',
      untertitel: '',
      beschreibungstext_online: '',
      aufnahmetechnik: '',
      rechte_ring: '',
      studiengaenge: '',
      weblinks: [],
    },
  ]);
  const [projectDataLoaded, setProjectDataLoaded] = useState(false);

  const [projectMediaData, setProjectMediaData] = useState([]);
  const [projectMediaDataLoaded, setProjectMediaDataLoaded] = useState(false);

  const [bildergalerieQuellen, setBildergalerieQuellen] = useState([]);
  const [downloadQuellen, setDownloadQuellen] = useState([
    {
      file_name: '',
      file_size: '',
    },
  ]);
  const [containerHeight, setContainerHeight] = useState('');
  const [appClientWidth, setAppClientWidth] = useState(
    window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  );

  // FUNCTIONS
  async function loadProjectDataFromApi() {
    setProjectDataLoaded(false);

    await fetch(`${process.env.REACT_APP_API}/one_specific_video?projekt_ID=${projectId}`)
      .then((response) => response.json())
      .then(
        (result) => {
          setProjectDataLoaded(true);
          setProjectData(result);
        },
        (error) => {
          setProjectDataLoaded(true);
          console.log(error);
        }
      );
    createCookie('last_seen', projectId, 30, 10);

    await fetch(`${process.env.REACT_APP_API}/getPathsForGallery?projekt_ID=${projectId}`)
      .then((response) => response.json())
      .then(
        (result) => {
          setBildergalerieQuellen(result);
        },
        (error) => {
          console.log(error);
        }
      );

    await fetch(`${process.env.REACT_APP_API}/getPathsForGames?projekt_ID=${projectId}`)
      .then((response) => response.json())
      .then(
        (result) => {
          setDownloadQuellen(result);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  async function loadProjectMediaDataFromApi() {
    setProjectMediaDataLoaded(false);

    await fetch(`${process.env.REACT_APP_API}/generateVideoSources?projektID=${projectId}`)
      .then((response) => response.json())
      .then(
        (result) => {
          setProjectMediaData(result);
          setProjectMediaDataLoaded(true);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  function setClientWidthListener() {
    window.addEventListener('resize', () => {
      setAppClientWidth(window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);
    });
  }

  // EFFECTS
  useEffect(() => {
    window.scrollTo(0, 0);
    loadProjectDataFromApi();
    setClientWidthListener();
    setContainerHeight(projectData[0].aufnahmetechnik.length > 0 ? '350px' : '250px');
  }, [projectId]);

  useEffect(() => {
    loadProjectMediaDataFromApi();
  }, [projectData]);

  useEffect(() => {
    setProjectId(props.match.params.id);
  }, [props.match.params.id]);

  // RENDER
  return (
    <div>
      <Router key={projectId}>
        <div className="videopage-container">
          {
            // prüfen ob die Daten angekommen sind
            // eslint-disable-next-line no-nested-ternary
            userIsAuthenticated !== null && projectMediaDataLoaded ? (
              // weitere Fallunterscheidung Player oder Anmeldeseite
              // der User ist NICHT eingeloggt
              Number(userIsAuthenticated.auth_state) === NOT_AUTHORIZED &&
              // Projekt ist nicht öffentlich freigegeben
              (Number(projectData[0].rechte_ring) < OEFFENTLICH ||
                // Der User ist nicht eingeloggt
                (Number(userIsAuthenticated.auth_state) === NOT_AUTHORIZED &&
                  // Die Länge der Quellen ist null
                  Number(projectMediaData.length) === 0 &&
                  Number(projectData[0].rechte_ring) !== OEFFENTLICH)) &&
                  Number(projectData[0].rechte_ring) !== OEFFENTLICH ? (
                    // Anmeldeaufforderung
                    <div className="anmeldeaufforderung">
                      <>
                        <img src={LockImage} className="locked-icon" alt="Inhalt gesperrt" />
                        <h1 style={{ color: 'white' }}>Dieses Projekt ist nur für Angehörige der HdM freigegeben.</h1>
                        <a href={`https://hdm-stuttgart.de/mediathek/login?currentURL=${window.location.href}`}>
                          <img className="profile-icon" src={ProfileIcon} alt="Inhalt gesperrt" />
                        </a>
                        <h3 style={{ color: 'white' }}>
                          Melde Dich mit Deinen HdM-Kontodaten an,
                          <br />
                          um das Projekt zu entsperren.
                        </h3>
                      </>
                    </div>
                ) : (
                  // Rendering des Videoplayers
                  <div className="player-black-stripe">
                    <MediaPlayer
                      projectId={Number(projectId)}
                      projectMediaData={projectMediaData}
                      viewportWidth={appClientWidth}
                    />
                  </div>
                )
            ) : (
              <LoadingSpinner />
            )
          }
        </div>

        <NameTag daten={projectData} viewportWidth={appClientWidth} />

        <Reiter
          id={Number(projectId)}
          bilddaten={bildergalerieQuellen}
          downloadGames={downloadQuellen}
          viewportWidth={appClientWidth}
          daten={projectData}
        />
        <Switch>
          {/* Changes your page directly to details -> stört beim Videoplayer bearbeiten  */}
          <Redirect exact from="/mediathek/projectpage/:id" to="/mediathek/projectpage/:id/details" />
          <Route
            path="/mediathek/projectpage/:id/details"
            render={(properties) => (
              <Details {...properties} daten={projectData} viewportWidth={appClientWidth} divHeight={containerHeight} />
            )}
          />
          <Route
            path="/mediathek/projectpage/:id/team"
            render={(properties) => (
              <Team {...properties} daten={projectData} viewportWidth={appClientWidth} divHeight={containerHeight} />
            )}
          />
          <Route
            path="/mediathek/projectpage/:id/teilen"
            render={(properties) => (
              <Teilen {...properties} daten={projectData} viewportWidth={appClientWidth} divHeight={containerHeight} />
            )}
          />
          <Route
            path="/mediathek/projectpage/:id/bilder"
            render={(properties) => (
              <Images {...properties} bilderdaten={bildergalerieQuellen} viewportWidth={appClientWidth} />
            )}
          />
          <Route
            path="/mediathek/projectpage/:id/links"
            render={(properties) => (
              <Links {...properties} daten={projectData} viewportWidth={appClientWidth} divHeight={containerHeight} />
            )}
          />
          <Route
            path="/mediathek/projectpage/:id/download"
            render={(properties) => (
              <Download
                {...properties}
                downloadData={downloadQuellen}
                divHeight={containerHeight}
                viewportWidth={appClientWidth}
              />
            )}
          />
        </Switch>
        <MainWrapper>
          <div
            style={{
              background: 'rgb(31, 31, 31)',
              height: 'auto',
            }}
          >
            {projectDataLoaded ? (
              <SliderComponent
                sliderHeadline={`Von den Machern von ${handleCharacterEncoding(projectData[0].projekt_titel)}`}
                contentType={`select_projekt_from_makers?projektID=${projectId}&nur_oeffentlich=${
                  onlyShowPublicProjects ? 1 : 0
                }`}
                userRights={userIsAuthenticated.auth_state}
                parentCallback={(value) => setProjectId(value)}
              />
            ) : null}
            {readCookie('last_seen').toString().length > 1 ? (
              <SliderComponent
                sliderHeadline="Könnte Dir gefallen"
                contentType={`new_resolveParamsRecommendation?nur_oeffentlich=${onlyShowPublicProjects ? 1 : 0}`}
                recentlyViewed={readCookie('last_seen')}
                userRights={userIsAuthenticated.auth_state}
                parentCallback={(value) => setProjectId(value)}
              />
            ) : (
              <SliderComponent
                sliderHeadline="Neu in der Mediathek"
                contentType={`latest_added_projects?nur_oeffentlich=${onlyShowPublicProjects ? 1 : 0}`}
                userRights={userIsAuthenticated.auth_state}
                parentCallback={(value) => setProjectId(value)}
              />
            )}
          </div>
        </MainWrapper>
      </Router>
    </div>
  );
}

export default VideoProjectPage;
